import z from "zod/v4";
import { anyScoreboardSchema, scoreTimeSeriesPointSchema } from "./scores.ts";
import { anyLiveGameTeamStatsSchema } from "./stats.ts";
import { pbpEventSchema } from "./responses.ts";
import { leagueIdSchema } from "../enums/LeagueId.ts";

export const liveGameScoreNewTimeSeriesPointSchema = z.object({
  name: z.literal("liveGameScoreNewTimeSeriesPoint"),
  data: scoreTimeSeriesPointSchema,
});

export type LiveGameScoreNewTimeSeriesPoint = z.infer<typeof liveGameScoreNewTimeSeriesPointSchema>;

export const liveGameScoreboardUpdateSchema = z.object({
  name: z.literal("liveGameScoreboardUpdate"),
  data: anyScoreboardSchema,
});

export type LiveGameScoreboardUpdate = z.infer<typeof liveGameScoreboardUpdateSchema>;

export const liveGameTeamStatsUpdateSchema = z.object({
  name: z.literal("liveGameTeamStatsUpdate"),
  data: anyLiveGameTeamStatsSchema,
});

export type LiveGameTeamStatsUpdate = z.infer<typeof liveGameTeamStatsUpdateSchema>;

export const livePbpEventUpdateSchema = z.object({
  name: z.literal("livePbpEventUpdate"),
  data: z.object({
    leagueId: leagueIdSchema,
    eventId: z.string(),
    pbp: pbpEventSchema,
  }),
});

export type LivePbpEventUpdate = z.infer<typeof livePbpEventUpdateSchema>;

export const livePbpEventDeleteSchema = z.object({
  name: z.literal("livePbpEventDelete"),
  data: z.object({
    leagueId: leagueIdSchema,
    eventId: z.string(),
    pbpEventId: z.string(),
  }),
});

export type LivePbpEventDelete = z.infer<typeof livePbpEventDeleteSchema>;